import React, { Component } from 'react'
import Dropdown from "react-dropdown";
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';

class linkAccountAddress extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            value: "Choose Account Type",
            stateNamePopup: "",
        }
    }

    handleOnclickSelect = (e) => {
        this.setState({
          state: e.value,
          stateNamePopup: e.label,
        });
        this.props.onChangeAddressSelect(e.value,e.label);
    };
    
    render() {
      const {
        AllStates,
      } = this.props.data;
  
      const options = [];
      options.push({ value: "", label: "State", name: "state" });
      AllStates.map((item) =>
        options.push({
          value: item.stateId,
          label: item.stateName,
          name: item.stateName,
        })
      );
        return (
            <div className="link-acc">
            <h2 className="text-center tab-h">
              {/* {this.props.addMultipleAccountState == true
                ? "Add Account"
                : "Link Account"} */}
            </h2>
            <h3 className="text-center tab-h3">Enter Address Details</h3>
            <div className="row  top-tab w-link-tab">
              <form onSubmit={this.props.handlePopupSubmit}></form>
              <div class="input-field col m12 t-left">
                <input
                  placeholder="Address 1"
                  class="form-control tab-input"
                  type="text"
                  name="address1Popup"
                  value={this.props.address1Popup}
                  onChange={this.props.onChangeAddress}
                />
                <label class="active top-l" for="Address 1">
                  Address 1
                </label>
                <div className="error-class" style={{ fontSize: 12, color: "red" }}>
                  {this.props.address1PopupError}
                </div>
              </div>
    
              <div class="input-field col m12 t-left">
                <input
                  placeholder="Address 2"
                  class="form-control tab-input"
                  type="text"
                  name="address2Popup"
                  value={this.props.address2Popup}
                  onChange={this.props.onChangeAddress}
                />
                <label class="active top-l" for="Address 1">
                Address 2
                </label>
                <div className="error-class" style={{ fontSize: 12, color: "red" }}>
                  {this.props.address2PopupError}
                </div>
              </div>
    
              <div class="input-field col m12 t-left">
                <input
                  placeholder="City"
                  class="form-control tab-input"
                  type="test"
                  name="cityPopup"
                  value={this.props.cityPopup}
                  onChange={this.props.onChangeAddress}
                />
                <label class="active top-l" for="City">
                  City
                </label>
                <div className="error-class" style={{ fontSize: 12, color: "red" }}>
                  {this.props.cityPopupError}
                </div>
              </div>
    
              <div class="input-field col m12 t-left dropdown-form">
                <label className="active top-l">State</label>
    
                <Dropdown
                  name="state"
                  className="browser-default"
                  options={options}
                  onChange={this.handleOnclickSelect}
                  value={this.props.statePopupName}
                  placeholder="State"
                />
                <div className="error-class" style={{ fontSize: 12, color: "red" }}>
                  {this.props.statePopupError}
                </div>
              </div>
    
              <div class="input-field col m12 t-left">
                <input
                  placeholder="Zip Code"
                  class="form-control tab-input"
                  type="number"
                  name="zipPopup"
                  value={this.props.zipPopup}
                  onChange={this.props.onChangeAddress}
                />
                <label class="active top-l" for="Zip">
                Zip Code
                </label>
                <div className="error-class" style={{ fontSize: 12, color: "red" }}>
                  {this.props.zipPopupError}
                </div>
              </div>
            </div>
          </div>
        )
    }
}

const mapStateToProps = (state) => {
  return{
    data: state.data,
  }
};

export default withAlert(connect(mapStateToProps, null)(linkAccountAddress));
